import { Injectable, Inject } from '@angular/core';
import { AppConfig, AppConfiguration } from 'src/configuration';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { RequestBase } from 'src/app/Models/input.model/RequestBase';
import { environment } from 'src/environments/environment';
import { map, filter } from 'rxjs/operators';
import { ResponseClassListAll, ResponseStudentsClass, ResponseClassListAllOnline } from 'src/app/Models/output.model/ResponseClassListAll';

@Injectable({
  providedIn: 'root'
})
export class ClassTypeService {

  constructor(
    @Inject(AppConfig) private readonly appConfig: AppConfiguration,
    private http: HttpClient
  ) { }
  getList(token): Observable<any> {
    return this.http.get<any>(this.appConfig.TeacherUrl + 'ClassType/ListAll', {
      headers: new HttpHeaders()
        .set('Authorization', `Bearer ${token}`)
    }).pipe(map(z => { return z }))
  }
}
